import React, { useMemo } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';
import SubHeader from '../SubHeader.jsx';
import LinkedFileCard from '../projects/ChangeStrategy/ChangeStrategyOverview/LinkedFileCard.jsx';
import QuestionBlueIcon from '../icons/QuestionBlueIcon.jsx';
import CustomTooltip from '../CustomTooltip.jsx';
import MilestoneCard from '../projects/ChangeStrategy/ChangeStrategyOverview/MilestoneCard.jsx';
import OverviewTextField from '../OverviewTextField.jsx';
import styles from './PortfolioOverview.module.css';

const PortfolioOverview = ({ portfolio }) => {
  const renderFields = useMemo(() => {
    if (portfolio) {
      return portfolio.custom_fields.map((field, index) => (
        <OverviewTextField
          key={field.key || `field-${index}`}
          isFieldWithEditor={portfolio.custom_fields.some(
            (item) => item.editor && item.key === field.key
          )}
          entity={portfolio}
          field={field}
          index={index}
        />
      ));
    }
  }, [portfolio]);

  return (
    <div className="component component-bg-white p-0">
      <SubHeader bgWhite className="py-0">
        <Row>
          <Col xs={3} className={styles.profileLeftBlock}>
            <div className={`${styles.stakeholderProfileAvatar} m-b-30`}>
              <img
                src={portfolio.image}
                alt="portfolio-avatar"
                sizes="300x290"
              />
            </div>
            <h4
              className="column-header m-b-16"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <p className="m-0">{getOrgTermsContent('portfolioMilestones')}</p>
              <CustomTooltip
                placement="right"
                tooltip={
                  <div style={{ maxWidth: '256px' }}>
                    <strong>
                      <h5
                        style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          lineHeight: '20px',
                          color: '#153142',
                        }}
                        className="m-b-8"
                      >
                        {getOrgTermsContent('portfolioMilestones')}
                      </h5>
                    </strong>
                    <p
                      style={{
                        fontSize: '12px',
                        fontWeight: '400',
                        lineHeight: '20px',
                        color: '#7F8FA4',
                      }}
                      className="m-b-0 text-muted"
                    >
                      {getOrgTermsContent('portfolioMilestonesDescription')}
                    </p>
                  </div>
                }
                id="tooltip"
              >
                <Button
                  aria-label="View Support for Change modal"
                  type="button"
                  className="flex flex-align-center m-l-8 btn-last-update-icon"
                >
                  <QuestionBlueIcon />
                </Button>
              </CustomTooltip>
            </h4>

            <strong className="bordered text-muted">
              Total:&nbsp;
              <span className="count" style={{ color: '#27B0E0' }}>
                {portfolio.milestones.length}
              </span>
            </strong>
            {portfolio.milestones.length ? (
              portfolio.milestones.map((milestone, index) => (
                <MilestoneCard key={`mile-${milestone.id}`} {...milestone} />
              ))
            ) : (
              <p className="m-t-16">
                There are no {getOrgTermsContent('portfolioMilestones')} at this
                time.
              </p>
            )}
          </Col>
          <Col xs={9} className={styles.profileRightBlock}>
            <h2 className="column-header m-b-16">
              {getOrgTermsContent('portfolio')} Details
            </h2>
            <Row className="flex flex-wrap flex-align-start">
              {portfolio ? renderFields : null}
            </Row>

            <h2
              style={{ background: '#F7FAFD', padding: 12 }}
              className="m-b-16"
            >
              <div className="flex horizontal-label">
                <h2
                  className="horizontal-label"
                  style={{ fontSize: '20px', marginRight: '20px' }}
                >
                  Linked Files
                </h2>
                <strong
                  className="bordered text-muted"
                  style={{ fontSize: '14px' }}
                >
                  Total :&nbsp;
                  <span className="text-primary" style={{ fontSize: '14px' }}>
                    {portfolio.linked_files.length}
                  </span>
                </strong>
              </div>
            </h2>

            {portfolio.linked_files.length ? (
              <Row
                style={{
                  padding: '10px 14px',
                  borderBottom: '1px solid #DFE2E5',
                }}
              >
                <Col xs="5">
                  <p className="text-muted">File Name</p>
                </Col>
                <Col xs="4">
                  <span className="text-muted">Uploaded By</span>
                </Col>
                <Col xs="3">
                  <p className="text-muted">Date Uploaded</p>
                </Col>
              </Row>
            ) : null}
            {portfolio.linked_files.length ? (
              portfolio.linked_files.map((link) => (
                <LinkedFileCard key={`link-${link.id}`} {...link} />
              ))
            ) : (
              <p>
                There are no Linked Files at this time. Linked Files allow you
                to add supporting documentation and materials to the{' '}
                {getOrgTermsContent('portfolio')} page.
              </p>
            )}
          </Col>
        </Row>
      </SubHeader>
    </div>
  );
};

export default PortfolioOverview;
